
export const Footer = () => {
  return (
    <footer className="py-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <img 
              src="/lovable-uploads/d9d55f21-709c-4984-a6a6-05ded8e6ce2c.png" 
              alt="Agent V Logo" 
              className="h-8 w-auto mr-2" 
            />
            <span className="text-lg font-semibold">Agent V</span>
          </div>
          <div className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Agent V. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};
